export default function genererCritereRechercheTourneeFaceSemaine() {
  return {
    auto: null,
    avecLaisserEnPlaceVente: null,
    tourneeId: null,
    afficheurIds: [],
    sansAfficheur: null,
    typeProduits: [],
  };
}
